import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import LoginForm from '../components/auth/LoginForm'
import Logo from '../components/Logo'

export default function LoginPage() {
  const { user, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    // Se usuário já está logado, redirecionar para home
    if (user && !loading) {
      navigate('/', { replace: true })
    }
  }, [user, loading, navigate])

  // Mostrar loading enquanto verifica autenticação
  if (loading) {
    return (
      <div className="min-h-screen page-bg flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  // Se usuário já está logado, não mostrar a página
  if (user) {
    return null
  }

  return (
    <div className="min-h-screen page-bg flex flex-col">
      {/* Header */}
      <div className="border-b nav-bg">
        <div className="container mx-auto py-4 flex items-center justify-center">
          <Logo />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-4">
        <LoginForm 
          onSuccess={() => navigate('/', { replace: true })}
        />
      </div>

      {/* Footer */}
      <div className="border-t nav-bg">
        <div className="container mx-auto py-4 text-center text-sm text-gray-600 dark:text-gray-400">
          © 2024 Lamyda. Todos os direitos reservados.
        </div>
      </div>
    </div>
  )
}
